import styled, { css } from "styled-components";
import { StyledP } from "base/BaseStyle";

export const IconContainer = styled.div`
  width: ${({ $sm }) => ($sm ? "50px" : "80px")};
  height: ${({ $sm }) => ($sm ? "50px" : "80px")};
  border-radius: 40px;
  border: 1px solid ${({ theme }) => theme.borderGray};
  justify-content: center;
  align-items: center;
  overflow: hidden;
  display: flex;
  img {
    width: ${({ $sm }) => ($sm ? "50px" : "80px")};
    height: ${({ $sm }) => ($sm ? "50px" : "80px")};
  }
`;

export const CustomStyledP = styled(StyledP)`
  ${({ $sm }) =>
    $sm
      ? css`
          text-wrap: wrap;
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : ``}
`;
